import React from 'react';
import PropertyDocuments from './PropertyDocuments';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import { useSidebar } from '../../shared/contexts/SidebarContext';

const SalesPropertyTemplate = ({ from }) => {
  const { collapsed } = useSidebar();

  return (
    <Layout>
      <div
        className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
          collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
        }`}>
        <Header data={{ name: `Property Templates` }} />
      </div>

      <div className="w-full min-h-full bg-gray-100 mt-[4.4rem]">
        <PropertyDocuments from={'sales'} />
      </div>
    </Layout>
  );
};

export default SalesPropertyTemplate;
